import React from 'react';
import './add visiting.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon } from "mdbreact";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message, TreeSelect, DatePicker } from "antd";
const { TreeNode } = TreeSelect;

class Addvisiting extends React.Component {
    state = {
        fullname: '',
        phone: '',
        project: null,
        projects: [],
        visitingDate: null,
        status: 'DONE',
        report: ''

    };

    constructor(props) {
        super(props)
        window.scrollTo(0, 0)
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
    }

    componentDidMount() {
        this.getProjects()
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
    }
    getProjects = () => {
        axios.get(`${BASE_END_POINT}projects/withoutPagenation/get`)
            .then(response => {
                console.log(response.data)
                this.setState({ projects: response.data.data })
            })
            .catch(error => {
                console.log("ALL projects ERROR")
                console.log(error.response)
            })
    }

    add = () => {
        const { fullname, phone, project, status, report, visitingDate } = this.state
        if (hasValue(fullname) && hasValue(phone) && project != null, visitingDate != null) {
            let l = message.loading('Wait..', 2.5)
            let data = {
                fullname: fullname,
                phone: phone,
                project: project,
                status: status,
                visitingDate: visitingDate,
                report: report,
            }
            axios.post(`${BASE_END_POINT}visitings`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.currentUser.token}`,
                    'Accept-Language': this.props.isRTL ? 'ar' : 'en'
                },
            })
                .then(response => {
                    console.log("visiting UPDATED  ", response.data)
                    l.then(() => message.success(allStrings.done, 2.5))
                    this.props.history.goBack()
                })
                .catch(error => {
                    console.log(error.response)
                    l.then(() => message.error(error.response.data.errors[0].msg, 2.5))
                })
        }
    }



    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
        this.add()
    };

    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    render() {
        console.log("type", this.state.type)
        if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('VISITINGS')) return <Redirect to='/Home' />

        return (
            <div className="App">
                <MDBContainer>
                    <MDBRow>
                        <MDBCol md="12">
                            <div className="infoCard">
                                <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                                    <CardMedia
                                        style={{ height: "0px" }}
                                    />
                                    <CardHeader></CardHeader>
                                    <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                                        <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                                            <span className="material-icons" style={{ color: 'white', fontSize: 23 }}>assignment</span>
                                        </div>
                                        <div className="tableTitle" style={{
                                            display: 'inline-block', marginTop: '-60px',
                                            marginLeft: '0', marginRight: '0'
                                        }}>
                                            <p>{allStrings.add}</p>
                                        </div>
                                    </div>
                                    <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                                        <MDBContainer>

                                            <MDBRow>
                                                <MDBCol md="12">
                                                    <form
                                                        className="needs-validation"
                                                        onSubmit={this.submitHandler}
                                                        noValidate
                                                    >
                                                        <div className="grey-text">
                                                            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.fullname} <span style={{ color: '#ef4444' }}>*</span> </label>
                                                                        <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} type="text" id="form645" name="fullname" className="form-control" required onChange={this.changeHandler} validate placeholder="أدخل الاسم الكامل..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form56" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.phone} <span style={{ color: '#ef4444' }}>*</span></label>
                                                                        <input onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^0-9+]/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} type="text" id="form56" name="phone" className="form-control" required onChange={this.changeHandler} validate placeholder="أدخل رقم الهاتف..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            <MDBRow>
                                                                <MDBCol md="6">
                                                                    <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.project} <span style={{ color: '#ef4444' }}>*</span></label>
                                                                    <TreeSelect virtual={false}
                                                                        showSearch={true}
                                                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                                                        treeCheckable={false}
                                                                        treeNodeFilterProp="title"
                                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                                        placeholder={allStrings.project}
                                                                        onChange={(value) => {
                                                                            console.log(value)
                                                                            this.setState({ project: value });
                                                                        }}
                                                                    >
                                                                        {this.state.projects.map(val => (
                                                                            <TreeNode value={val.id} title={this.props.isRTL ? val.name_ar : val.name_en} key={val.id} />
                                                                        ))}
                                                                    </TreeSelect>
                                                                </MDBCol>
                                                                <MDBCol md="6">
                                                                    <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.status} <span style={{ color: '#ef4444' }}>*</span></label>
                                                                    <TreeSelect virtual={false}
                                                                        showSearch={true}
                                                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                                                        treeCheckable={false}
                                                                        treeNodeFilterProp="title"
                                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                                        placeholder={allStrings.status}
                                                                        onChange={(value) => {
                                                                            console.log(value)
                                                                            this.setState({ status: value });
                                                                        }}

                                                                    >
                                                                        <TreeNode value="PENDING" title={allStrings.pending} key="PENDING" />
                                                                        <TreeNode value="DONE" title={allStrings.done} key="DONE" />
                                                                        <TreeNode value="CANCELED" title={allStrings.canceled} key="CANCELED" />

                                                                    </TreeSelect>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            <MDBRow>
                                                                <MDBCol md="12">
                                                                    <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.visitingDate} <span style={{ color: '#ef4444' }}>*</span></label>
                                                                    <DatePicker
                                                                        dropdownAlign={{ points: ['bl', 'tl'] }}
                                                                        placement="topLeft"
                                                                        showTime={{ use12Hours: true, format: 'h:mm A' }}
                                                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', marginBottom: '1rem' }}
                                                                        onChange={(date, dateString) => {
                                                                            this.setState({ visitingDate: dateString })
                                                                        }}
                                                                        placeholder={allStrings.visitingDate}
                                                                    />
                                                                </MDBCol>
                                                            </MDBRow>
                                                            <MDBRow>
                                                                <MDBCol md="12">
                                                                    <div class="md-form">
                                                                        <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.visitingReport} <span style={{ color: '#ef4444' }}>*</span></label>
                                                                        <br></br>
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        <textarea style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="form645" name="report" class="form-control" onChange={this.changeHandler} validate placeholder="أدخل التقرير..." />
                                                                    </div>
                                                                </MDBCol>
                                                            </MDBRow>
                                                        </div>
                                                        <br></br>
                                                        <br></br>
                                                        <div className="text-center">
                                                            <MDBBtn
                                                                style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff' }}
                                                                rounded
                                                                color="#1D9598"
                                                                type="submit"
                                                                className="btn-block z-depth-1a"
                                                            >
                                                                <MDBIcon icon="plus" className="mr-2" />
                                                                {allStrings.add}
                                                            </MDBBtn>

                                                        </div>
                                                    </form>
                                                </MDBCol>
                                            </MDBRow>
                                        </MDBContainer>
                                    </CardContent>
                                </Card>
                            </div>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>

            </div>
        )
    }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(Addvisiting)
);